import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled, { css } from 'styled-components';
import { color, getComponentOverride, marginAttributes, propsBlocker, reset, spacing, typography, widthAttributes } from '../../system';

var getLabelContainerStyle = function getLabelContainerStyle(_ref) {
  var label = _ref.label;
  var result = {};

  if (typeof label === 'string') {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", ";\n        "])), typography('labelLarge'));
  }

  return result;
};

export var ActionSheetRoot = styled.div.withConfig(propsBlocker)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    align-items: center;\n    background-color: ", ";\n    display: flex;\n    justify-content: space-between;\n    padding: ", " ", ";\n    ", ";\n\n    ", ";\n    ", ";\n    ", ";\n"])), reset, color('primary.lightest'), spacing(4), spacing(6), typography('paragraphMedium'), getComponentOverride('ActionSheet'), marginAttributes, widthAttributes);
export var ActionSheetLabelContainer = styled.div.withConfig(propsBlocker)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n"])), getLabelContainerStyle);